import { Color } from '@/types'
import { Badge as BaseBadge, BadgeProps as BaseBadgeProps } from '../base/badge'

type BadgeColor = BaseBadgeProps['color']

export type Category = {
  name: string
  color: BadgeColor | Color
}

interface BadgeProps {
  category: Category
}

export const Badge = ({ category }: BadgeProps) => {
  const { color, name } = category

  return <BaseBadge color={color?.toLowerCase() as BadgeColor} data-testid="category-badge">{ name }</BaseBadge>
}
